import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface ExcellenceModalData {
  hseTierXp: number;
  tierXpMax: number;
  perfRawPoints: number;
  engRawPoints: number;
  performancePct: number;
  performanceScore: number;
  performanceTotalLabel: string;
  performanceMonths: Array<{ month: string; val: string }>;
  engagementPct: number;
  engagementScore: number;
  engagementFormula: string;
  engagementTotalLabel: string;
  engagementMonths: Array<{ month: string; val: string; detail: string }>;
  recognitionItems: Array<{ label: string; active: boolean; icon?: string; top5?: Array<{ rank?: number; unitName?: string; name?: string; country?: string; flag?: string; isCurrent?: boolean }> }>;
  achievements: Array<{ icon: string; name: string; date: string; xp?: number }>;
  top5HseUnits?: Array<{ rank: number; unitName: string; country: string; flag: string; isCurrent?: boolean }>;
  selectedCountryFlag?: string;
  selectedMonth?: string;
}

@Injectable({ providedIn: "root" })
export class ExcellenceModalService {
  isOpen$    = new BehaviorSubject<boolean>(false);
  modalData$ = new BehaviorSubject<ExcellenceModalData | null>(null);

  setData(data: ExcellenceModalData): void {
    this.modalData$.next(data);
  }

  open(): void {
    this.isOpen$.next(true);
    const ionContent = document.querySelector("ion-content.dashboard-wrapper") as HTMLElement;
    if (ionContent) ionContent.style.setProperty("--overflow", "hidden");
  }

  close(): void {
    this.isOpen$.next(false);
    const ionContent = document.querySelector("ion-content.dashboard-wrapper") as HTMLElement;
    if (ionContent) ionContent.style.removeProperty("--overflow");
  }
}
